import React, { useEffect, useState } from 'react'
import { SelectWithLabel } from 'components/Form'
import { channels as channelsNewApi } from 'api'
import { toastMessage } from 'utils/messages'
import _get from 'lodash.get'
import { PhoneInput } from 'components/Form'
import { lang } from 'utils/helpers'
import TimeAndDate from 'utils/TimeAndDate'
import TimerSelector from 'components/common/TimerSelector'

const DisplayDialCode = ['sms', 'only_phone']

/**
 * AuthenticationType
 * @param {object} props
 * @param {string} props.id
 * @param {object} props.value
 * @param {function} props.onChange
 */
const AuthenticationType = (props) => {
  const { value = {}, onChange, label, placeholder, options, description, channel, required, prop } = props
  const _options = options.map(it => ({ value: it.value, label: lang(it.label) }))
  const [authenticationIdOptions, setAuthenticationIdOptions] = useState([])

  useEffect(()=>{
    if (['sms', 'email'].includes(value)) getChannelsSMS({ value })
  }, [value])

  const getChannelsSMS = async ({ value }) => {
    try {
      let channels = []

      if (value === 'sms') {
        channels = await channelsNewApi.getList('sms', 'twilio')
      } else if (value === 'email') {
        channels = await channelsNewApi.getList('', 'chatmail')
      }

      setAuthenticationIdOptions(channels.data.map((elem) => ({
        label: elem.value.email || elem.value.botId,
        value: elem._id
      })))
    } catch ({ response = {}, message }) {
      const data = _get(response, 'data', {})
      toastMessage(lang(data.type || 'generic_error'), 'error')
    }
  }

  const setType = (type) => {
    onChange(type)
    if (type !== 'sms') {
      onChange('', 'value.smsAuthenticationId')
    }
    if (!DisplayDialCode.includes(type)) {
      onChange('', 'value.countryDialCode')
    }
  }

  const setSMS = (id) => {
    onChange(id, 'value.smsAuthenticationId')
  }

  const setDialCode = (data) => {
    onChange(data.country, 'value.countryDialCode')
    onChange(data.dialCode, 'value.dialCode')
  }

  const setRedirectExpirationTime = (value) => {
    onChange(value, 'redirectExpirationTime')
  }

  const valuesTimer = TimeAndDate.millisecondsToUnit({
    time: channel?.redirectExpirationTime?.time || 12 * 60 * 60 * 1000,
    unit: channel?.redirectExpirationTime?.unit?.trim() || 'hours'
  })
  
  return (
    <div className='channel-field select' id={`container_${prop}`}>
      {label && <label>{lang(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <div className='field-content grid grid--small'>
        <SelectWithLabel
          placeholder={placeholder || lang('dashboard_select')}
          options={_options}
          onChange={(value) => setType(value.value)}
          value={value ? _options.find(it => it.value === value) : ''}
        />
        {description && <p className='description'>{lang(description)}</p>}
      </div>
      {['sms', 'email'].includes(value) && (
        <div className='field-content grid grid--small'>
          <SelectWithLabel
            placeholder={lang('dashboard_select')}
            options={authenticationIdOptions}
            onChange={(value) => setSMS(value.value)}
            value={value ? authenticationIdOptions.find(it => it.value === channel.value.smsAuthenticationId) : ''}
          />
        </div>
      )}
      {channel.key === 'chatweb' && DisplayDialCode.includes(value) ? (
        <div className='channel-field select' id={`channels_sms_dial_code_${prop}`}>
          <label>{lang('label_dial_code_field')}</label>
          <div className='field-content grid grid--small'>
            <PhoneInput
              onlyDialCode
              id='channels_sms_dial_code'
              country={channel.value.countryDialCode}
              value={channel.value.dialCode}
              onChange={setDialCode}
            />
            <p className='description'>{lang('label_dial_code_description')}</p>
          </div>
        </div>
      ) : null}
      {
        value === 'redirectFromChannel' && (
          <div className='field-content grid grid--large'>
            <TimerSelector
              label={null}
              value={valuesTimer}
              onChange={value => {
                setRedirectExpirationTime(
                  TimeAndDate.timeToMilliseconds({
                    unit: value.unit, time: value.time
                  })
                )
              }}
              includes={["minutes", "hours", "days", "months"]}//TODO AVOID HARDCODED
            />
          </div>
        )
      }
    </div>
  )
}

export default AuthenticationType
